import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page-heading" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "notice error"
}
const _hoisted_6 = {
  key: 1,
  class: "notice"
}
const _hoisted_7 = {
  key: 0,
  class: "notice error"
}
const _hoisted_8 = { class: "report-layout" }
const _hoisted_9 = { class: "report-result" }
const _hoisted_10 = {
  key: 0,
  class: "loader-overlay"
}
const _hoisted_11 = {
  key: 1,
  class: "panel table-panel"
}
const _hoisted_12 = {
  key: 0,
  class: "loading"
}
const _hoisted_13 = { class: "report-config panel" }
const _hoisted_14 = { class: "preset-bar" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "report-config-tabs" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "report-option-tools" }
const _hoisted_19 = { class: "report-options-list vertical unified" }
const _hoisted_20 = ["draggable", "onDragstart", "onDrop"]
const _hoisted_21 = ["value"]
const _hoisted_22 = ["open"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["draggable", "onDragstart", "onDrop"]
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 1,
  class: "report-filter-list"
}
const _hoisted_27 = { class: "report-date-range" }
const _hoisted_28 = ["max"]
const _hoisted_29 = ["min"]
const _hoisted_30 = { class: "report-filter-grid" }
const _hoisted_31 = {
  key: 0,
  class: "report-relevance-filter"
}
const _hoisted_32 = { class: "report-filter-actions" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 3,
  class: "panel report-exports"
}
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "loading"
}
const _hoisted_37 = {
  key: 1,
  class: "loading"
}
const _hoisted_38 = { class: "report-export-main" }
const _hoisted_39 = {
  key: 0,
  class: "error-text"
}
const _hoisted_40 = { class: "report-export-progress" }
const _hoisted_41 = {
  key: 0,
  class: "export-progress-track"
}
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { class: "report-export-actions" }
const _hoisted_45 = ["href"]
const _hoisted_46 = ["href"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = _resolveComponent("RouterLink")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("div", null, [
        _createElementVNode("small", null, "Аналитика"),
        _createElementVNode("h1", null, "Отчёты")
      ], -1 /* CACHED */)),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: _normalizeClass({primary:$setup.section==='builder'&&$setup.type==='report'}),
          onClick: _cache[0] || (_cache[0] = $event => {$setup.section='builder';$setup.type='report'})
        }, "Статистика игроков", 2 /* CLASS */),
        _createElementVNode("button", {
          class: _normalizeClass({primary:$setup.section==='builder'&&$setup.type==='traffic'}),
          onClick: _cache[1] || (_cache[1] = $event => {$setup.section='builder';$setup.type='traffic'})
        }, "Трафик", 2 /* CLASS */),
        _createElementVNode("button", {
          class: _normalizeClass({primary:$setup.section==='exports'}),
          onClick: $setup.showExports
        }, "Экспорты", 2 /* CLASS */),
        ($setup.section==='builder'&&$setup.type==='report')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              disabled: $setup.exportCreating,
              onClick: $setup.createReportExport
            }, _toDisplayString($setup.exportCreating ? "Запуск…" : "Экспорт CSV + XLSX"), 9 /* TEXT, PROPS */, _hoisted_3))
          : _createCommentVNode("v-if", true),
        ($setup.section==='builder')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "primary",
              disabled: $setup.loading,
              onClick: $setup.load
            }, "Построить", 8 /* PROPS */, _hoisted_4))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    ($setup.exportError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.exportError), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.exportNotice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.exportNotice), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.section==='builder')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          ($setup.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.error), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              ($setup.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("span", { class: "spinner" }, null, -1 /* CACHED */),
                    _createElementVNode("strong", null, "Загрузка отчёта…", -1 /* CACHED */)
                  ]))]))
                : _createCommentVNode("v-if", true),
              ($setup.data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("table", null, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...$setup.data.group_by, ...$setup.data.metrics], (column) => {
                            return (_openBlock(), _createElementBlock("th", { key: column }, _toDisplayString($setup.label(column)), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.rows, (row, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...$setup.data.group_by, ...$setup.data.metrics], (column) => {
                              return (_openBlock(), _createElementBlock("td", { key: column }, [
                                (column==='partner' && row[column]?.id)
                                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                                      key: 0,
                                      to: `/partners/${row[column].id}`,
                                      class: "report-partner-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(row[column].name), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                                  : (column==='partner')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(row[column]?.name || row[column]?.external_id || '—'), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createTextVNode(_toDisplayString($setup.value(column, row[column])), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    (!$setup.data.rows.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Нет данных по выбранным фильтрам"))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("aside", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.selectedPresetId) = $event)),
                  "aria-label": "Пресет отчёта",
                  onChange: $setup.applyPreset
                }, [
                  _cache[22] || (_cache[22] = _createElementVNode("option", { value: "" }, "Пресет: не выбран", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentPresets, (preset) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: preset.id,
                      value: preset.id
                    }, _toDisplayString(preset.name), 9 /* TEXT, PROPS */, _hoisted_15))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelSelect, $setup.selectedPresetId]
                ]),
                _createElementVNode("button", {
                  class: "icon-button",
                  title: "Сохранить пресет",
                  "aria-label": "Сохранить пресет",
                  onClick: $setup.savePreset
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("svg", {
                    viewBox: "0 0 24 24",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", { d: "M5 4h12l2 2v14H5zM8 4v6h8V4M8 20v-6h8v6" })
                  ], -1 /* CACHED */)
                ]))]),
                ($setup.selectedPresetId)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "icon-button danger",
                      title: "Удалить пресет",
                      "aria-label": "Удалить пресет",
                      onClick: $setup.deletePreset
                    }, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("path", { d: "M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5" })
                      ], -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: _normalizeClass({active:$setup.configTab==='metrics'}),
                  onClick: _cache[3] || (_cache[3] = $event => {$setup.configTab='metrics';$setup.optionSearch=''})
                }, [
                  _cache[25] || (_cache[25] = _createTextVNode("Столбцы ", -1 /* CACHED */)),
                  _createElementVNode("span", null, _toDisplayString($setup.selectedMetrics.length), 1 /* TEXT */)
                ], 2 /* CLASS */),
                _createElementVNode("button", {
                  class: _normalizeClass({active:$setup.configTab==='groups'}),
                  onClick: _cache[4] || (_cache[4] = $event => {$setup.configTab='groups';$setup.optionSearch=''})
                }, [
                  _cache[26] || (_cache[26] = _createTextVNode("Группировки ", -1 /* CACHED */)),
                  _createElementVNode("span", null, _toDisplayString($setup.selectedGroups.length), 1 /* TEXT */)
                ], 2 /* CLASS */),
                _createElementVNode("button", {
                  class: _normalizeClass({active:$setup.configTab==='filters'}),
                  onClick: _cache[5] || (_cache[5] = $event => {$setup.configTab='filters';$setup.optionSearch=''})
                }, [
                  _cache[27] || (_cache[27] = _createTextVNode("Фильтры ", -1 /* CACHED */)),
                  ($setup.activeFilterCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString($setup.activeFilterCount), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */)
              ]),
              ($setup.configTab!=='filters')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.optionSearch) = $event)),
                        placeholder: "Найти…"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $setup.optionSearch]
                      ]),
                      _createElementVNode("button", { onClick: $setup.selectAll }, "Все"),
                      _createElementVNode("button", { onClick: $setup.resetOptions }, "Сбросить")
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.standardOptions, (item) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: item,
                          class: _normalizeClass({selected:$setup.currentSelection.includes(item),dragging:$setup.draggedOption===item}),
                          draggable: $setup.currentSelection.includes(item),
                          onDragstart: $event => ($setup.startOptionDrag($event,item)),
                          onDragend: _cache[8] || (_cache[8] = $event => ($setup.draggedOption=null)),
                          onDragover: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
                          onDrop: _withModifiers($event => ($setup.dropOption(item)), ["prevent"])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["drag-handle", {disabled:!$setup.currentSelection.includes(item)}])
                          }, "⋮⋮", 2 /* CLASS */),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: item,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.currentSelection) = $event))
                          }, null, 8 /* PROPS */, _hoisted_21), [
                            [_vModelCheckbox, $setup.currentSelection]
                          ]),
                          _createElementVNode("span", null, _toDisplayString($setup.label(item)), 1 /* TEXT */)
                        ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_20))
                      }), 128 /* KEYED_FRAGMENT */)),
                      ($setup.configTab==='groups'&&$setup.advancedOptions.length)
                        ? (_openBlock(), _createElementBlock("details", {
                            key: 0,
                            class: "report-advanced-options",
                            open: $setup.optionSearch ? true : undefined
                          }, [
                            _createElementVNode("summary", null, [
                              _cache[28] || (_cache[28] = _createTextVNode("Расширенные ", -1 /* CACHED */)),
                              ($setup.selectedAdvancedCount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString($setup.selectedAdvancedCount), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.advancedOptions, (item) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: item,
                                class: _normalizeClass({selected:$setup.currentSelection.includes(item),dragging:$setup.draggedOption===item}),
                                draggable: $setup.currentSelection.includes(item),
                                onDragstart: $event => ($setup.startOptionDrag($event,item)),
                                onDragend: _cache[11] || (_cache[11] = $event => ($setup.draggedOption=null)),
                                onDragover: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
                                onDrop: _withModifiers($event => ($setup.dropOption(item)), ["prevent"])
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["drag-handle", {disabled:!$setup.currentSelection.includes(item)}])
                                }, "⋮⋮", 2 /* CLASS */),
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  value: item,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.currentSelection) = $event))
                                }, null, 8 /* PROPS */, _hoisted_25), [
                                  [_vModelCheckbox, $setup.currentSelection]
                                ]),
                                _createElementVNode("span", null, _toDisplayString($setup.label(item)), 1 /* TEXT */)
                              ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_24))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 8 /* PROPS */, _hoisted_22))
                        : _createCommentVNode("v-if", true)
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("label", null, [
                        _cache[29] || (_cache[29] = _createTextVNode("Дата от", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($setup.filters.from) = $event)),
                          type: "date",
                          max: $setup.filters.to
                        }, null, 8 /* PROPS */, _hoisted_28), [
                          [_vModelText, $setup.filters.from]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[30] || (_cache[30] = _createTextVNode("Дата до", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($setup.filters.to) = $event)),
                          type: "date",
                          min: $setup.filters.from
                        }, null, 8 /* PROPS */, _hoisted_29), [
                          [_vModelText, $setup.filters.to]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("label", null, [
                        _cache[31] || (_cache[31] = _createTextVNode("Аффпрограмма", -1 /* CACHED */)),
                        _createVNode($setup["SearchMultiSelect"], {
                          modelValue: $setup.filters.connection_ids,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($setup.filters.connection_ids) = $event)),
                          options: $setup.filterOptions.integrations,
                          "search-placeholder": "Найти аффпрограмму…"
                        }, null, 8 /* PROPS */, ["modelValue", "options"])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[32] || (_cache[32] = _createTextVNode("Партнёр", -1 /* CACHED */)),
                        _createVNode($setup["SearchMultiSelect"], {
                          modelValue: $setup.filters.partner_ids,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($setup.filters.partner_ids) = $event)),
                          options: $setup.filterOptions.partners,
                          "search-placeholder": "Название или ID в интеграции…"
                        }, null, 8 /* PROPS */, ["modelValue", "options"])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[33] || (_cache[33] = _createTextVNode("Кампания", -1 /* CACHED */)),
                        _createVNode($setup["SearchMultiSelect"], {
                          modelValue: $setup.filters.campaign_external_ids,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (($setup.filters.campaign_external_ids) = $event)),
                          options: $setup.filterOptions.campaigns,
                          "search-placeholder": "Найти кампанию…"
                        }, null, 8 /* PROPS */, ["modelValue", "options"])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[34] || (_cache[34] = _createTextVNode("Промо", -1 /* CACHED */)),
                        _createVNode($setup["SearchMultiSelect"], {
                          modelValue: $setup.filters.promo_external_ids,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => (($setup.filters.promo_external_ids) = $event)),
                          options: $setup.filterOptions.promos,
                          "search-placeholder": "Найти промо…"
                        }, null, 8 /* PROPS */, ["modelValue", "options"])
                      ])
                    ]),
                    ($setup.type==='traffic')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_31, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($setup.filters.relevant_only) = $event)),
                            type: "checkbox"
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, $setup.filters.relevant_only]
                          ]),
                          _cache[35] || (_cache[35] = _createElementVNode("span", null, [
                            _createElementVNode("strong", null, "Только релевантное"),
                            _createElementVNode("small", null, "Исключить восстановленный трафик за период отсутствия партнёра")
                          ], -1 /* CACHED */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("button", { onClick: $setup.clearReportFilters }, "Сбросить"),
                      _createElementVNode("button", {
                        class: "primary",
                        disabled: $setup.loading,
                        onClick: $setup.load
                      }, "Применить", 8 /* PROPS */, _hoisted_33)
                    ])
                  ]))
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock("section", _hoisted_34, [
          _createElementVNode("header", null, [
            _cache[36] || (_cache[36] = _createElementVNode("div", null, [
              _createElementVNode("h2", null, "Экспорты статистики игроков"),
              _createElementVNode("p", null, "Файлы CSV и XLSX хранятся семь дней. Параметры выгрузки остаются в истории.")
            ], -1 /* CACHED */)),
            _createElementVNode("button", {
              disabled: $setup.exportsLoading,
              onClick: $setup.loadExports
            }, "Обновить", 8 /* PROPS */, _hoisted_35)
          ]),
          ($setup.exportsLoading&&!$setup.exports.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Загрузка экспортов…"))
            : (!$setup.exports.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Экспортов пока нет"))
              : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.exports, (item) => {
            return (_openBlock(), _createElementBlock("article", {
              key: item.id,
              class: "report-export-row"
            }, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("strong", null, "Отчёт по игрокам #" + _toDisplayString(item.id), 1 /* TEXT */),
                _createElementVNode("span", null, _toDisplayString($setup.exportSummary(item)), 1 /* TEXT */),
                _createElementVNode("small", null, [
                  _createTextVNode(_toDisplayString(item.user.name) + " · создан " + _toDisplayString($setup.formatDate(item.created_at)), 1 /* TEXT */),
                  (item.row_count!==null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · " + _toDisplayString($setup.formatNumber(item.row_count)) + " строк", 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]),
                (item.error_message)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_39, _toDisplayString(item.error_message), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("strong", null, _toDisplayString($setup.exportStatus(item)), 1 /* TEXT */),
                (['pending','running'].includes(item.status))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("span", {
                        style: _normalizeStyle({width:`${item.progress}%`})
                      }, null, 4 /* STYLE */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (['pending','running'].includes(item.status))
                  ? (_openBlock(), _createElementBlock("small", _hoisted_42, _toDisplayString(item.progress) + "%", 1 /* TEXT */))
                  : (item.expires_at&&item.status==='succeeded')
                    ? (_openBlock(), _createElementBlock("small", _hoisted_43, "до " + _toDisplayString($setup.formatDate(item.expires_at)), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_44, [
                (item.csv_url)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "export-link",
                      href: item.csv_url
                    }, "CSV " + _toDisplayString($setup.formatBytes(item.csv_size)), 9 /* TEXT, PROPS */, _hoisted_45))
                  : _createCommentVNode("v-if", true),
                (item.xlsx_url)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "export-link",
                      href: item.xlsx_url
                    }, "XLSX " + _toDisplayString($setup.formatBytes(item.xlsx_size)), 9 /* TEXT, PROPS */, _hoisted_46))
                  : _createCommentVNode("v-if", true),
                (!['pending','running'].includes(item.status))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      onClick: $event => ($setup.retryExport(item))
                    }, "Повторить", 8 /* PROPS */, _hoisted_47))
                  : _createCommentVNode("v-if", true),
                (!['pending','running','deleted','expired'].includes(item.status))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "danger",
                      onClick: $event => ($setup.deleteExport(item))
                    }, "Удалить файлы", 8 /* PROPS */, _hoisted_48))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
  ]))
}